import hotelBedSizeType from "./hotelBedSizeType/zh_cn.yml";
import hotelMealType from "./hotelMealType/zh_cn.yml";
import payType from "./payType/zh_cn.yml";
import bookingPayType from "./bookingPayType/zh_cn.yml";
import bookingStatus from "./bookingStatus/zh_cn.yml";
import bookingOptionStatus from "./bookingOptionStatus/zh_cn.yml";
import seo from "./seo/zh_cn.yml";
import hotelChildrenSettingCategorySimpleChildrenSetting from "./hotelChildrenSettingCategorySimpleChildrenSetting/zh_cn.yml";
import hotelChildrenSettingCategoryComplexChildrenSetting from "./hotelChildrenSettingCategoryComplexChildrenSetting/zh_cn.yml";
import hotelChildrenSettingCategorySimple from "./hotelChildrenSettingCategorySimple/zh_cn.yml";
import hotelChildrenSettingMealType from "./hotelChildrenSettingMealType/zh_cn.yml";
import genderType from "./genderType/zh_cn.yml";
import bookingErrorCode from "./bookingErrorCode/zh_cn.yml";

export const constantZhCn: any = {
  hotelBedSizeType: hotelBedSizeType["zh_cn"]["constantHotelBedSizeType"],
  hotelMealType: hotelMealType["zh_cn"]["constantHotelMealType"],
  payType: payType["zh_cn"]["constantPayType"],
  bookingPayType: bookingPayType["zh_cn"]["constantBookingPayType"],
  bookingStatus: bookingStatus["zh_cn"]["constantBookingStatus"],
  bookingOptionStatus:
    bookingOptionStatus["zh_cn"]["constantBookingOptionStatus"],
  seo: seo["zh_cn"]["constantSeo"],
  hotelChildrenSettingCategorySimpleChildrenSetting:
    hotelChildrenSettingCategorySimpleChildrenSetting["zh_cn"][
      "constantHotelChildrenSettingCategorySimpleChildrenSetting"
    ],
  hotelChildrenSettingCategoryComplexChildrenSetting:
    hotelChildrenSettingCategoryComplexChildrenSetting["zh_cn"][
      "constantHotelChildrenSettingCategoryComplexChildrenSetting"
    ],
  hotelChildrenSettingCategorySimple:
    hotelChildrenSettingCategorySimple["zh_cn"][
      "constantHotelChildrenSettingCategorySimple"
    ],
  hotelChildrenSettingMealType:
    hotelChildrenSettingMealType["zh_cn"][
      "constantHotelChildrenSettingMealType"
    ],
  genderType: genderType["zh_cn"]["constantGenderType"],
  bookingErrorCode: bookingErrorCode["zh_cn"]["constantBookingErrorCode"],
};
